/**
 * 提现记录 — 所有状态视图 (pending / approved / rejected), hits the same
 * /api/admin/withdraw list endpoint as 提现审核 but with no default filter
 * and no action buttons. Read access still needs `platform.withdraw.list`.
 */
import { WithdrawReviewPage } from './WithdrawReviewPage';

export function WithdrawLogPage() {
  return <WithdrawReviewPage defaultStatusFilter={undefined} title="提现记录" />;
}
